import { Input          } from "./Input";
import { HourlyForm, MonthlyForm    } from "../Data/Atoms";
import { LocationInput  } from "./LocationInput";
import { Control, FieldErrors,
         UseFormRegister,
         UseFormSetValue,
         UseFormWatch } from "react-hook-form";
import { LocalDate } from "@js-joda/core";
import { showBrowserDate } from "../Data/Date";
import { Setter } from "../Data/Types";

export interface MonthlySearchProps {
    register: UseFormRegister<MonthlyForm>;
    watch:    UseFormWatch<MonthlyForm>;
    setValue: UseFormSetValue<MonthlyForm>;
    errors:   FieldErrors<MonthlyForm>;
    setPlace: (place: google.maps.places.Place | null) => void;
    control: Control<MonthlyForm>; 
}

export function MonthlySearch( props: MonthlySearchProps ) {
    const { register, errors } = { ...props };
    const minEntryDate = showBrowserDate( LocalDate.now() );
    return <div>
        <div>
        <LocationInput
        name="location"
        control={props.control}
        rules={{ required: "Location is required" }}
        onPlaceSelect={(place) => props.setPlace(place)}
        />
        </div>
        <div id="monthly-search-dates">
            <Input
                min={minEntryDate}
                {...register( "startDate", { required: "Start Date is required",
                    min: { value: minEntryDate, message: "Start Date must be in the future" } } )}
                type="date"
                label="Start Date"
                placeholder="Today"
                explanation="The first day you need to park"
                error={errors.startDate} />
        </div>
    </div>;
}